// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  DefaultPage,
} from './';

export default {
  path: '',
  name: 'Site map',
  childRoutes: [
    { path: 'en/site-map', name: 'Default page', component: DefaultPage, isIndex: true },
    { path: 'es/site-map', name: 'Default page', component: DefaultPage, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/site-map/route.js